import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Avatar,
  Box, 
  IconButton, 
  Menu, 
  MenuItem,
  Tooltip,
  Typography, 
} from '@mui/material';

import Logo from "../../assets/icons/logo-white.svg";
import NA from '../utils/NA';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';

import ConfirmationModal from '../modals/ConfirmationModal';

import WatchTowerNavigation from './WatchTowerNavigation';
import ConsumerNavigation from './ConsumerNavigation';
import BusinessNavigation from './BusinessNavigation/index';
import CertificationNavigation from './CertificationNavigation';
import SDKNavigation from './SDKNavigation';
import SupportNavigation from './SupportNavigation';

import {
  moduleList
} from "../../views/homePage/HomePage";

import { LogOut } from "../../redux/actions/authActions";

import "./styles.scss";

const Navigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentModule, setCurrentModule] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const businessCoreState = useSelector(state => state["business.core"]);
  const businessFusionCCState = useSelector(state => state["business.fusion.cc"]);

  const [profileAnchor, setProfileAnchor] = useState(null);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const handleCloseProfileMenu = () => {
    setProfileAnchor(null);
    setProfileMenuOpen(false);
  };

  useEffect(() => {
    var route = location.pathname.split("/");
    var module = route[1];
    var page = route.splice(2).join("/");

    switch(module){      
      case "watch":
        setCurrentModule(0);
        switch(page){
          case "": return setCurrentPage(0);
          case "contact-requests": return setCurrentPage(1);
          case "demo-certify-domains": return setCurrentPage(2);
          case "demo-approvals": return setCurrentPage(3);
          case "demo-analytics": return setCurrentPage(4);
          case "app-versions": return setCurrentPage(5);
          // submodule -> environment
          case "environment": return setCurrentPage(0);
          case "environment/consumer": return setCurrentPage(1);
          case "environment/business": return setCurrentPage(2);
          case "environment/sdk": return setCurrentPage(3);
          case "environment/support": return setCurrentPage(4);

          default: return setCurrentPage(0);
        }

      case "business":
        setCurrentModule(1);
        switch(page){
          case "": return setCurrentPage(0);
          case "system-config": return setCurrentPage(1);
          case "uploaded-files": return setCurrentPage(2);
          case "currencies": return setCurrentPage(3);
          case "error-logs": return setCurrentPage(4);
          // submodule -> extensions
          case "extension": return setCurrentPage(0);
          // submodule -> notifications
          case "notifications": return setCurrentPage(7);
          case "notifications/email-activities": return setCurrentPage(0);
          case "notifications/email-templates": return setCurrentPage(1); 
          case "notifications/email-template-sync": return setCurrentPage(8); 
          case "notifications/email-tester": return setCurrentPage(2);
          case "notifications/email-broadcast": return setCurrentPage(3);
          case "notifications/sms-templates": return setCurrentPage(4); 
          case "notifications/sms-activities": return setCurrentPage(5);
          case "notifications/otp-records": return setCurrentPage(6); 
          // submodule -> subscriptions
          case "subscriptions": return setCurrentPage(0);
          case "subscriptions/products": return setCurrentPage(1);
          case "subscriptions/delivery-methods": return setCurrentPage(2);
          case "subscriptions/integrations": return setCurrentPage(3);
          case "subscriptions/subscription-plans": return setCurrentPage(4);
          case "subscriptions/services": return setCurrentPage(5);
          case "subscriptions/plan-addons": return setCurrentPage(6);
          case "subscriptions/company-plan-addons": return setCurrentPage(7);
          case "subscriptions/disallowed-services": return setCurrentPage(8);
          // submodule -> identity
          case "identity": return setCurrentPage(0); 
          case "identity/tenants": return setCurrentPage(1); 
          case "identity/companies": return setCurrentPage(2);
          case "identity/branches": return setCurrentPage(3); 
          case "identity/users": return setCurrentPage(4);
          case "identity/user-consents": return setCurrentPage(5);
          case "identity/company-employees": return setCurrentPage(6);
          case "identity/internal-users": return setCurrentPage(7);
          case "identity/internal-users-mfa": return setCurrentPage(8);
          case "identity/internal-user-sessions": return setCurrentPage(9);
          case "identity/mfa-backup-codes": return setCurrentPage(10);
          case "identity/user-sessions": return setCurrentPage(11);
          // submodule -> core
          case "core": return setCurrentPage(0); 
          case "core/global/currencies": return setCurrentPage(0); 
          case "core/global/industries": return setCurrentPage(1); 
          case "core/global/account-types": return setCurrentPage(2); 
          case "core/global/chart-of-accounts": return setCurrentPage(3); 
          case "core/global/vendors": return setCurrentPage(4); 
          case "core/global/customers": return setCurrentPage(5); 
          case "core/global/currency-cloud/countries": return setCurrentPage(0); 
          case "core/global/currency-cloud/currencies": return setCurrentPage(1); 
          case "core/global/currency-cloud/payment-countries": return setCurrentPage(2); 
          case "core/global/currency-cloud/payment-currencies": return setCurrentPage(3); 
          case "core/global/currency-cloud/payment-purposes": return setCurrentPage(4); 
          case "core/global/currency-cloud/payment-country-currency-xref": return setCurrentPage(5); 
          case "core/global/currency-cloud/payment-services": return setCurrentPage(6); 
          case "core/global/currency-cloud/collection-countries": return setCurrentPage(7); 
          case "core/global/currency-cloud/collection-currencies": return setCurrentPage(8); 
          case "core/global/currency-cloud/collection-country-currency-xref": return setCurrentPage(9); 
          case "core/global/currency-cloud/collection-services": return setCurrentPage(10); 
          case "core/tenants": return setCurrentPage(0); 
          case "core/tenants/overview": return setCurrentPage(11); 
          case "core/tenants/billing-explorer": return setCurrentPage(12); 
          case "core/tenants/fee-ranges": return setCurrentPage(13); 
          case "core/tenants/bank-account-types": return setCurrentPage(0); 
          case "core/tenants/banks": return setCurrentPage(1); 
          case "core/tenants/holidays": return setCurrentPage(2); 
          case "core/tenants/cost-objects": return setCurrentPage(3); 
          case "core/tenants/tenant-bank-accounts": return setCurrentPage(4);
          case "core/tenants/service-fees": return setCurrentPage(5); 
          case "core/tenants/international-service-fees": return setCurrentPage(6); 
          case "core/tenants/international-usd-to-usd-service-fees": return setCurrentPage(7); 
          case "core/tenants/payment-frequencies": return setCurrentPage(8); 
          case "core/tenants/payment-methods": return setCurrentPage(9);
          case "core/tenants/categories": return setCurrentPage(10); 
          case "core/companies": return setCurrentPage(0); 
          case "core/companies/overview": return setCurrentPage(0); 
          case "core/companies/company-config": return setCurrentPage(1); 
          case "core/companies/employees": return setCurrentPage(2); 
          case "core/companies/bank-accounts": return setCurrentPage(3); 
          case "core/companies/transactions": return setCurrentPage(4); 
          case "core/companies/domestic-blnk-wallet": return setCurrentPage(5); 
          case "core/companies/international-blnk-wallet": return setCurrentPage(6); 
          case "core/companies/billing": return setCurrentPage(7); 
          case "core/smart-lcs-approvals": return setCurrentPage(0);
          // submodule -> trade-defence
          case "core/trade-defence/brokers": return setCurrentPage(0);
          case "core/trade-defence/compliance-vectors": return setCurrentPage(1);
          case "core/trade-defence/company-vector-pref": return setCurrentPage(2);
          case "core/trade-defence/system-validation-rules": return setCurrentPage(3);
          case "core/trade-defence/usitc-hts-codes": return setCurrentPage(4);
          case "core/trade-defence/ustr-exclusions": return setCurrentPage(5);
          case "core/trade-defence/usitc-revisions": return setCurrentPage(19);
          case "core/trade-defence/usitc-spi-rates": return setCurrentPage(20);
          case "core/trade-defence/usitc-chapter99-mappings": return setCurrentPage(21);
          case "core/trade-defence/staging-entries": return setCurrentPage(6);
          case "core/trade-defence/staging-documents": return setCurrentPage(7);
          case "core/trade-defence/customs-entries": return setCurrentPage(8);
          case "core/trade-defence/entry-documents": return setCurrentPage(9);
          case "core/trade-defence/pivot-masters": return setCurrentPage(10);
          case "core/trade-defence/pivot-rows": return setCurrentPage(11);
          case "core/trade-defence/ci-masters": return setCurrentPage(12);
          case "core/trade-defence/ci-lines": return setCurrentPage(13);
          case "core/trade-defence/form-7501-headers": return setCurrentPage(14);
          case "core/trade-defence/form-7501-lines": return setCurrentPage(15);
          case "core/trade-defence/bol-headers": return setCurrentPage(16);
          case "core/trade-defence/assembly-sessions": return setCurrentPage(17);
          case "core/trade-defence/assembly-documents": return setCurrentPage(18);
          case "core/trade-defence/sc-node-visualizer": return setCurrentPage(28);
          case "core/trade-defence/sc-nodes": return setCurrentPage(22);
          case "core/trade-defence/sc-node-content": return setCurrentPage(23);
          case "core/trade-defence/sc-node-revision-status": return setCurrentPage(24);
          case "core/trade-defence/sc-segmentation-runs": return setCurrentPage(25);
          case "core/trade-defence/sc-page-furniture-log": return setCurrentPage(26);
          case "core/trade-defence/ch99-ingest": return setCurrentPage(27);
          case "core/trade-defence/tariff-simulator": return setCurrentPage(29);
          case "core/trade-defence/ch99-rule-engine": return setCurrentPage(30);
          case "core/trade-defence/sc-ch99-rules": return setCurrentPage(31);
          case "core/trade-defence/sc-rule-interactions": return setCurrentPage(32);
          case "core/trade-defence/sc-hts-ch99-mappings": return setCurrentPage(33);
          case "core/reports/domestic-transfers": return setCurrentPage(0); 
          case "core/reports/international-transfers": return setCurrentPage(1); 
          // submodule -> fusion
          case "fusion": return setCurrentPage(0); 
          case "fusion/activities": return setCurrentPage(1); 
          // case "fusion/orum": return setCurrentPage(0); 
          // case "fusion/orum/businesses": return setCurrentPage(1); 
          // case "fusion/orum/persons": return setCurrentPage(2); 
          // case "fusion/orum/transfers": return setCurrentPage(3); 
          // case "fusion/orum/verify": return setCurrentPage(4); 
          // case "fusion/orum/webhooks": return setCurrentPage(5); 
          case "fusion/wyzia": return setCurrentPage(0); 
          case "fusion/wyzia/campaigns": return setCurrentPage(1); 
          case "fusion/wyzia/deposits": return setCurrentPage(2); 
          case "fusion/wyzia/withdrawals": return setCurrentPage(3);
          case "fusion/wyzia/transactions": return setCurrentPage(4);
          case "fusion/wyzia/kyc": return setCurrentPage(5);
          case "fusion/wyzia/due-dilligence": return setCurrentPage(6);
          case "fusion/wyzia/miscellaneous": return setCurrentPage(7);
          case "fusion/currency-cloud": return setCurrentPage(0); 
          case "fusion/currency-cloud/beneficiaries": return setCurrentPage(0); 
          case "fusion/currency-cloud/conversions": return setCurrentPage(1); 
          case "fusion/currency-cloud/rates": return setCurrentPage(2); 
          case "fusion/currency-cloud/payments": return setCurrentPage(3); 
          case "fusion/currency-cloud/transfers": return setCurrentPage(4); 
          case "fusion/altcard": return setCurrentPage(0); 
          case "fusion/altcard/parties": return setCurrentPage(1); 
          case "fusion/altcard/parties-bank-accounts": return setCurrentPage(2); 
          // submodule -> webhook
          case "webhook": return setCurrentPage(0); 
          case "webhook/activities": return setCurrentPage(1); 
          case "webhook/webhook-logs": return setCurrentPage(2); 
          // submodule -> accounting-tpi
          case "accounting-tpi": return setCurrentPage(0);
          case "accounting-tpi/quickbooks-desktop/connections": return setCurrentPage(0);
          case "accounting-tpi/quickbooks-desktop/operations": return setCurrentPage(1);
          case "accounting-tpi/quickbooks-desktop/tickets": return setCurrentPage(2);
          case "accounting-tpi/quickbooks-desktop/payload-injector": return setCurrentPage(3);
          case "accounting-tpi/quickbooks-desktop/failed-operations": return setCurrentPage(4);
          case "accounting-tpi/quickbooks-desktop/mapping-anomalies": return setCurrentPage(5);
          case "accounting-tpi/quickbooks-desktop/class-mapping": return setCurrentPage(6);
          case "accounting-tpi/quickbooks-desktop/account-mapping": return setCurrentPage(7);
          case "accounting-tpi/quickbooks-desktop/sales-tax-mapping": return setCurrentPage(8);
          case "accounting-tpi/quickbooks-desktop/item-mapping": return setCurrentPage(9);
          case "accounting-tpi/quickbooks-desktop/vendor-mapping": return setCurrentPage(10);
          case "accounting-tpi/quickbooks-desktop/customer-mapping": return setCurrentPage(11);
          case "accounting-tpi/quickbooks-desktop/bill-mapping": return setCurrentPage(12);
          case "accounting-tpi/quickbooks-desktop/bill-payment-mapping": return setCurrentPage(13);
          case "accounting-tpi/quickbooks-desktop/invoice-mapping": return setCurrentPage(14);
          case "accounting-tpi/quickbooks-desktop/invoice-payment-mapping": return setCurrentPage(15);
          case "accounting-tpi/quickbooks-desktop/journal-entry-mapping": return setCurrentPage(16);
          case "accounting-tpi/quickbooks-desktop/check-mapping": return setCurrentPage(15);
          case "accounting-tpi/quickbooks-online": return setCurrentPage(0);
          case "accounting-tpi/xero": return setCurrentPage(0);

          default: return setCurrentPage(0);
        }

      case "certification":
        setCurrentModule(2);
        switch(page){
          case "": return setCurrentPage(0);
          case "authorities": return setCurrentPage(1);
          case "dbe": return setCurrentPage(2);
          case "license-batches": return setCurrentPage(3);
          case "workflow-templates": return setCurrentPage(4);
          case "template-allotments": return setCurrentPage(5);
          case "workflow-template-groups": return setCurrentPage(6);
          case "template-group-allotments": return setCurrentPage(7);

          default: return setCurrentPage(0);
        }

      case "consumer":
        setCurrentModule(3);
        switch(page){
          case "": return setCurrentPage(0);
          case "users": return setCurrentPage(1);
          case "internal-users": return setCurrentPage(2);
          // submodule -> extension
          case "extension": return setCurrentPage(0);
          case "extension/card": return setCurrentPage(1);
          case "extension/price": return setCurrentPage(2);
          // submodule -> payments
          case "payments/currencies": return setCurrentPage(0);
          case "payments/users": return setCurrentPage(1);
          // submodule -> virtualCards
          case "virtual-cards/currencies": return setCurrentPage(0);
  
          default: return setCurrentPage(0);
        }

      case "support":
        setCurrentModule(4);
        switch(page){
          case "": return setCurrentPage(0);
          case "issues": return setCurrentPage(1);
          // submodule -> config
          case "config/categories": return setCurrentPage(0);
          case "config/stages": return setCurrentPage(1);
    
          default: return setCurrentPage(0);
        }
      
      case "sdk":
        setCurrentModule(5);
        switch(page){
          case "": return setCurrentPage(0);
    
          default: return setCurrentPage(0);
        }

      default: return setCurrentModule(-1);
    }

  }, [currentPage, location.pathname]);

  // ======================= Log out handler ============================
  // Calls the backend logout endpoint so the server can clear the HttpOnly
  // auth + CSRF cookies (the frontend can't touch the HttpOnly one itself).
  // The LogOut thunk dispatches LOG_OUT and navigates back to /.
  const handleLogout = () => {
    dispatch(LogOut(navigate));
  }

  // ======================= Navigate handler ===========================
  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box className="nav">
      <ConfirmationModal 
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        title={"Log out"}
        onConfirm={handleLogout}
        />

      <Box className="nav__topbar flexCenterSBRow">
        <Box
          className="flexCenter_Row"
          gap={"40px"}>
          <img
            src={Logo}
            alt="logo"
            style={{ width: "140px", cursor: "pointer" }}
            onClick={() => {
              navigate("/home")
            }}
            />
          {
            currentModule >= 0
            &&
            <Typography
              variant='h6'>
              <i>{moduleList[currentModule].name}</i>
            </Typography>
          }
        </Box>

        {
          location.pathname.split("/").length === 5 &&
          location.pathname.split("/")[3] === "tenants" && 
          businessCoreState.selectedTenant !== null
          &&
          <Box
            className="flexCenter_Row">
            <Typography
              color={"grey"}>
              Selected Tenant:
            </Typography>&nbsp;
            <Typography>
              {businessCoreState?.selectedTenant?.tenant_name || <NA />}
            </Typography>
          </Box>
        }

        {
          location.pathname.split("/").length === 5 &&
          location.pathname.split("/")[3] === "companies" && 
          businessCoreState.selectedCompany !== null
          &&
          <Box
            className="flexCenter_Row">
            <Typography
              color={"grey"}>
              Selected Company:
            </Typography>&nbsp;
            <Typography>
              {businessCoreState?.selectedCompany?.company_name || <NA />}
            </Typography>
          </Box>
        }

        {
          location.pathname.split("/").length === 5 &&
          location.pathname.split("/")[3] === "currency-cloud" && 
          businessFusionCCState.selectedAccount !== null
          &&
          <Box
            className="flex__Column">
            <Box
              className="flexCenter_Row">
              <Typography
                color={"grey"}>
                Account:
              </Typography>&nbsp;
              <Typography>
                {businessFusionCCState?.selectedAccount?.accountName || <NA />}
              </Typography>
            </Box> 
            {
              "contact" in businessFusionCCState.selectedAccount
              &&
              <Box
                className="flexCenter_Row">
                <Typography
                  color={"grey"}>
                  On behalf of:
                </Typography>&nbsp;
                <Typography>
                  {businessFusionCCState?.selectedAccount?.contact?.firstName || <NA />}
                  {" "}{businessFusionCCState?.selectedAccount?.contact?.lastName || <NA />}
                </Typography>
              </Box>
            }
          </Box>
        }
        
        <Box
          className="flexCenter_Row"
          gap={"15px"}>
          <Tooltip
            title="Change module">
            <IconButton
              onClick={() => {
                navigate("/home")
              }}>
              <AppsRoundedIcon 
                fontSize='large'
                sx={{ color: "grey" }}
                />
            </IconButton>
          </Tooltip>
          <IconButton
            onClick={(event) => {
              setProfileAnchor(event.currentTarget);
              setProfileMenuOpen(!profileMenuOpen);
            }}>
            <Avatar>
              L
            </Avatar>
          </IconButton>
        </Box>
        <Menu
          id="basic-menu"
          anchorEl={profileAnchor}
          open={profileMenuOpen}
          onClose={handleCloseProfileMenu}
        >
          <MenuItem
            className='flexCenterSBRow'
            sx={{ gap: "15px" }}
            onClick={() => {
              navigate("/profile");
              handleCloseProfileMenu();
            }}>
            <PersonOutlineIcon />
            Profile
          </MenuItem>
          <MenuItem
            className='flexCenterSBRow'
            sx={{ gap: "15px" }}
            onClick={() => {
              setConfirmationModalOpen(true);
              handleCloseProfileMenu();
            }}>
            <LogoutIcon />
            Logout
          </MenuItem>
        </Menu>
      </Box>
      <Box 
        display={"flex"} 
        flexDirection={"row"}>
        <Box
          overflow={"auto"}
          minWidth={"300px"}
          height={"calc(100vh - 72px)"}>
          {
            currentModule === 0
            ?
            <WatchTowerNavigation 
              path={location.pathname.split("/")}
              currentPage={currentPage}
              navigate={handleNavigate}/>
            :
              currentModule === 1
              ?
              <BusinessNavigation 
                path={location.pathname.split("/")}
                currentPage={currentPage}
                navigate={handleNavigate}/>
              : 
                currentModule === 2
                ?
                <CertificationNavigation 
                  path={location.pathname.split("/")}
                  currentPage={currentPage}
                  navigate={handleNavigate}/>
                :
                  currentModule === 3
                  ?
                  <ConsumerNavigation
                    path={location.pathname.split("/")}
                    currentPage={currentPage}
                    navigate={handleNavigate}/>
                  :
                    currentModule === 4
                    ?
                    <SupportNavigation
                      path={location.pathname.split("/")}
                      currentPage={currentPage}
                      navigate={handleNavigate}/>
                    :
                      currentModule === 5
                      ?
                      <SDKNavigation  
                        path={location.pathname.split("/")}
                        currentPage={currentPage}
                        navigate={handleNavigate}/>
                      :
                      <></>
          }
        </Box>
        <Box 
          padding={"15px 15px 15px 15px"} 
          width={"100%"}
          height={"calc(100vh - 74px)"}
          overflow={"auto"}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default Navigation;